import { appendScript } from '../../../../shared/utils/commonUtils';

const appendPassportWidgetsScript = (url) => {
  return new Promise((resolve) => {
    if (!url) {
      resolve(false);
      return;
    }
    const onReadyCallback = () => {
      window.APWWidget?.onReady((APW) => {
        window.APWWidget.renderer = APW;
        resolve(true);
      });
    };
    const onErrorCallback = () => {
      resolve(false);
    };
    appendScript(url, onReadyCallback, true, undefined, onErrorCallback);
  });
};

export default appendPassportWidgetsScript;
